module.exports = __webpack_public_path__ + "img/and.d4227482.svg";